import React, { Component } from 'react';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import headerLogo from '../../img/defi-logo-color-v3.png';
import poweredLogo from '../../img/powered-by-logo-v3.png';
import { PATH_ROOT } from '../../paths';

const src = localStorage.logo ? localStorage.logo : `/Home/GetLogo`;
class NotFound extends Component {
  render() {
    return (
      <div className="d-flex justify-content-center flex-column align-items-center" data-testid="not-found-page">
        <div className="col-xs-12 logo mt-4">
          <img src={src} alt="logo" height="40"/>
        </div>
        <div className="box">
          <Paper elevation={3} className="login-content-section">
            <div className="row center-xs">
              <div className="col-xs-12">
                <div className="box">
                  <h2 className="title mb-20">Page Not Found</h2>
                  <p className="sub-title mb-20">Sorry but the page you are looking for cannot be found.</p>
                  <Button
                    variant="contained"
                      id="go-home-button"
                     disableRipple
                      className="los-btn los-btn-primary shadow-none text-capitalize"
                    color="primary"
                    onClick={() => this.props.history.push(PATH_ROOT)}
                    data-testid="not-found-go-home-button"
                  >
                    Go Home
                  </Button>
                </div>
              </div>
            </div>
          </Paper>
          <a href="http://defisolutions.com" className="powered-img mb-5" target="_blank" rel="noopener noreferrer" data-testid="not-found-powered-by-link">
            <img src={poweredLogo} alt="logo" />
          </a>
        </div>
      </div>
    );
  }
}

export default NotFound;
